"use client";

import {useOnboardContext} from "@/app/(onboard)/OnboardContext";
import Step from "@/component/ui/Step";
import clsx from "clsx";

const OnboardStep = () => {
    const {processStep} = useOnboardContext();
    return (
        // <div className={clsx(
        //     "p-3 flex flex-row flex-wrap items-center justify-center gap-2 bg-brandlight rounded-xl",
        //     ""
        // )}>
        <div className="flex flex-row flex-wrap items-center justify-center-safe gap-2 p-3 mt-4 bg-brandlight rounded-xl">
            <Step count={1} title="Select Country" type={Number(processStep) === 1 ? "in_progress" : Number(processStep) > 1 ? "complete" : "default"}/>
            <Step count={2} title="Select Package" type={Number(processStep) === 2 ? "in_progress" : Number(processStep) > 2 ? "complete" : "default"}/>
            <Step count={3} title="Company Info" type={Number(processStep) === 3 ? "in_progress" : Number(processStep) > 3 ? "complete" : "default"}/>
            <Step count={4} title="Review & Pay" type={Number(processStep) === 4 ? "in_progress" : Number(processStep) > 4 ? "complete" : "default"}/>
        </div>
    )
}

export default OnboardStep;